import { useQuery } from '@tanstack/react-query'
import { equipmentApi, type AssignableUser } from '@/api/equipmentApi'
import { useMockApi } from '@/lib/useMock'
import { useTenant } from '@/providers/TenantProvider'

/** Mock roster so the New Event picker stays populated offline. */
const MOCK_USERS: AssignableUser[] = [
  { id: 'mock-paul', name: 'Paul P.', email: 'paul@example.com' },
  { id: 'mock-aaron', name: 'Aaron A.', email: 'aaron@example.com' },
  { id: 'mock-maria', name: 'Maria L.', email: 'maria@example.com' },
  { id: 'mock-devon', name: 'Devon S.', email: 'devon@example.com' },
]

/**
 * Technicians who can be assigned a maintenance event (id + display name), for the
 * worklist / New Event assignee picker. Falls back to a mock roster in mock mode.
 */
export function useAssignableUsers(): { users: AssignableUser[]; isLoading: boolean } {
  const { selectedTenantId } = useTenant()
  const tenantId = useMockApi ? 'mock' : selectedTenantId

  const query = useQuery({
    queryKey: ['assignable-users', tenantId] as const,
    enabled: tenantId !== null && !useMockApi,
    queryFn: () => equipmentApi.listAssignableUsers(tenantId as string),
  })

  return {
    users: useMockApi ? MOCK_USERS : (query.data ?? []),
    isLoading: query.isLoading && query.fetchStatus !== 'idle',
  }
}
